// FNP-58: form-shape Zod schema (replaces the prior Yup parallel schema).
import {z} from 'zod';

export const FilterFormSchema = z.object({
    entityType: z.string().optional(),
    syncStatus: z.string().optional(),
});
